import { Model, Attr, BelongsTo } from 'spraypaint'

import ApplicationRecord from '@/models/ApplicationRecord'
import MultiChoiceGiftCard from '@/models/MultiChoiceGiftCard'

@Model()
export default class UrsafEvent extends ApplicationRecord {
  static jsonapiType = 'ursaf_events'

  @Attr() id!: string
  @Attr() code!: string
  @Attr() name!: string
  @Attr() cseKind!: string
  @Attr() defaultDotationDuration!: string
  @Attr() active!: boolean
  @Attr() createdAt!: string
  @Attr() updatedAt!: string

  @BelongsTo() multiChoiceGiftCard!: MultiChoiceGiftCard
}
